import React, { useState } from 'react'

import {
  Action,
  BooleanField,
  FieldSpec,
  LinkedField,
  LinkedPathField,
  NumberField,
  PaginatedTable,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import { Container } from 'src/api/models'
import { ContainerLabel } from 'src/components/PrintLabel'
import { BulkPrint } from 'src/components/Print/Bulk'
import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  name: { id: 'name', label: 'Name', renderer: LinkedField(ValueField) },
  containerType: {
    id: 'containerType',
    label: 'Type',
    ordering: 'container_type',
    renderer: ValueField,
  },
  facility: {
    id: 'place.facility',
    label: 'Facility',
    ordering: 'place__facility__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  path: {
    id: 'objPath',
    label: 'Storage Path',
    ordering: 'place__search_path',
    renderer: LinkedPathField,
  },
  totalUnits: {
    id: 'totalUnits',
    label: 'Total Number of Units in Container',
    ordering: 'total_units',
    renderer: NumberField,
  },
  reviewNeeded: {
    id: 'reviewNeeded',
    label: 'Review Needed',
    ordering: 'review_needed',
    renderer: BooleanField,
  },
}

export const ContainerListTable = (props: ListTableProps) => {
  const { paginator, title, fields, bulkActions=[], extraBulkActions=[], exportConfig } = props
  const [selected, setSelected] = useState<Container[]>([])
  const { print, renderPrintComponent } = useAsyncPrint()

  const bulkOptions: { [key: string]: Action } = {
    printContainer: {
      label: 'Print Container',
      action: () => {
        print((props) => (
          <BulkPrint
            {...props}
            items={selected}
            render={({ obj, onReadyToPrint }) => {
              onReadyToPrint?.()
              return <ContainerLabel obj={obj} />
            }}
          />
        ))
      },
    },
  }

  return (
    <>
      {renderPrintComponent()}
      <PaginatedTable
        title={title || 'Containers'}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        onSelectedItem={setSelected}
        bulkActions={bulkActions?.map((action) => bulkOptions[action]).concat(extraBulkActions)}
        exportConfig={exportConfig}
      />
    </>
  )
}
